const styles = theme => ({
  paperContainer: {
    padding: '20px 20px 30px 20px',
    margin: '0 20px 0 20px',
  },
  note: {
    marginTop: 10,
    fontSize: theme.constants.fontSizes.regular,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  description: {
    fontSize: theme.constants.fontSizes.regular,
    lineHeight: 1.5,
    marginRight: 10,
  },
  proceedButton: {
    color: theme.palette.primary.contrastText,
    fontSize: theme.constants.fontSizes.regular,
    cursor: 'pointer',
    fontWeight: 'bold',
    border: 'none',
    width: '100%',
  },
  buttonDisabled: {
    color: theme.palette.primary.contrastText,
    fontSize: theme.constants.fontSizes.regular,
    cursor: 'pointer',
    fontWeight: 'bold',
    border: 'none',
    width: '100%',
    opacity: 0.7,
    '&:hover': {
      cursor: 'not-allowed',
    },
  },
  root: {
    padding: 20,
    paddingTop: 20,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '40vh',
    overflowY: 'auto',
  },
  breadcrumb: {
    marginLeft: 20,
    marginBottom: 20,
  },
});

export default styles;
